
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/chat/[[...slug]]",
      function () {
        return require("private-next-pages/chat/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/chat/[[...slug]]"])
      });
    }
  